import React from "react";

export default function FooterSmall({backgroundColor,absolute}) {


  return (
    <>
      <footer
      style={{backgroundColor}}
        className={
          (absolute
            ? `absolute w-full bottom-0 ${backgroundColor}`
            : "relative") + " pb-6"
        }
      >
        <div className="container mx-auto px-4">
          {/* <hr className="mb-6 border-b-1 border-blueGray-600" /> */}
          <div className="flex flex-wrap items-center justify-center">
            {/* Centering the copyright */}
            <div className="w-full px-4">
              <div className="text-xs text-white font-semibold py-1 text-center">
                Copyright © {new Date().getFullYear()}{" "}
                <a
                  href="https://ciichin.org/"
                  className="text-blueGray-500 hover:text-white-300 text-xs font-semibold py-1"
                >
                 CIIC-HIN Resource Management System
                </a>
              </div>
            </div>
            <div className="w-full md:w-8/12 px-4">
              <ul className="flex flex-wrap list-none md:justify-end justify-center">
                <li>
                  {/* <a
                    href="https://qtglobal.rw/"
                    className="text-white hover:text-blueGray-300 text-sm font-semibold block py-1 px-3"
                  >
                    QT Global
                  </a> */}
                </li>
                <li>
                  {/* <a
                    href="https://qtglobal.rw/#about-us"
                    className="text-white hover:text-blueGray-300 text-sm font-semibold block py-1 px-3"
                  >
                    About Us
                  </a> */}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}